module.exports = __webpack_public_path__ + "static/images/chatbots-bg.1c58bf5484c97c7a04bfbbd271dd887b.jpg";